<footer class="footer-area">
  <div class="container">
    <div class="row align-items-center">

      <div class="col-md-3 text-md-start text-center mb-3 mb-md-0">
        <a routerLink="/" class="d-inline-block">
          <img src="assets/img/logo.png" alt="Spitalul General CF Pașcani">
        </a>
      </div>

      <div class="col-md-5 text-center mb-3 mb-md-0">
        <ul class="contact-us-link">
          <li>
            <i class="bx bx-phone-call"></i> 
            <a href="tel:0232761300">0232 761 300</a>
          </li>
          <li>
            <i class="bx bx-envelope"></i>
            <a href="mailto:contact@spitalcfpascani.ro">contact@spitalcfpascani.ro</a>
          </li>
        </ul>
      </div>

      <div class="col-md-4 text-md-end text-center">
        <p class="mb-0 small">
          &copy; 2026 Spitalul General CF Pașcani.<br>
          Toate drepturile rezervate.
        </p>
      </div>

    </div>
  </div>

  <ngx-scrolltop></ngx-scrolltop>
</footer>
